import React from 'react';
import { Link } from 'react-router-dom';

const JoinRMPFamily = ({ infosetting, redirect }) => {
    return (
        <div className='column center padder hj-container'>
            <span className='home-banner-title'>Join the {infosetting.shortTitle} Family</span>
            <span className='hj-caption'>Love {infosetting.shortTitle}? Let's make it official.</span>


            <div className='hj-content'>
                <div className='hj-item'>
                    <i class="fa-solid fa-user-pen"></i>
                    <span>Manage and edit <br />your ratings</span>
                </div>
                <div className='hj-item'>
                    <i class="fa-solid fa-lock"></i>
                    <span>Your ratings are <br />always anonymous</span>
                </div>
                <div className='hj-item'>
                    <i class="fa-solid fa-thumbs-up"></i>
                    <span>Like or dislike <br />ratings</span>
                </div>
            </div>

            {/* Features Section */}
            {/* <section className="features-section">
                <div className="feature-card">
                    <div className="feature-icon">📈</div>
                    <h3>Real-time Ratings</h3>
                    <p>Up-to-date ratings based on user reviews</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">🔍</div>
                    <h3>Advanced Search</h3>
                    <p>Find adjusters by name, company, or location</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">🛡️</div>
                    <h3>Verified Reviews</h3>
                    <p>All reviews are authenticated and moderated</p>
                </div>
            </section> */}

            <Link className='btn hj-btn' to={`/auth/signup${redirect ? '?redirect=' + encodeURI(redirect) : ''}`}>
                Sign up now!
            </Link>

        </div>
    );
};

export default JoinRMPFamily;